if (!document.getElementById("multiselect_dropdown_styles")) {
  var style = document.createElement('style');
  style.setAttribute("id", "multiselect_dropdown_styles");
  style.innerHTML = ``;
  document.head.appendChild(style);
}

/*
 * Multiselect dropdown (based on https://github.com/admirhodzic/multiselect-dropdown), used by the "Supported locations" filter of the
 * partner directory sidebar. Changes made for the directory:
 * - optgroups ("Regions" / "Countries") and re-init safety after a Theme Editor section reload;
 * - an <option> may carry data-full (full name, tooltip + screen readers) and data-alias ("|" separated spellings that the search accepts),
 *   used when a long country name is displayed abbreviated (US, UAE, UK-GB); the option value stays the full lowercase name;
 * - keyboard access: the box is a focusable combobox (Enter / Space / ArrowDown open it, Esc closes and returns focus to the box,
 *   ArrowUp / ArrowDown / Home / End move through the rows, Enter toggles the active row, Space toggles it when the search box is empty,
 *   Tab leaves the dropdown and closes it), aria-expanded follows the panel, the "x" of a selected tag is a focusable button;
 * - select.syncOptions() re-reads option.selected into the rows and tags (used by qikify-custom.js for ?location= links).
 */
function MultiselectDropdown(options) {
  var config = {
    search: true,
    height: '15rem',
    placeholder: '', /* all visible texts come from attributes of the <select> (multiselect-txt-*, placeholder), printed by sections/qikify-partner-sidebar.liquid from locales/en.default.json */
    txtSelected: '',
    txtAll: '',
    txtRemove: '',
    txtSearch: '',
    txtSearchLabel: '',
    ...options
  };
  function newEl(tag, attrs) {
    var e = document.createElement(tag);
    if (attrs !== undefined) Object.keys(attrs).forEach(k => {
      if (k === 'class') { Array.isArray(attrs[k]) ? attrs[k].forEach(o => o !== '' ? e.classList.add(o) : 0) : (attrs[k] !== '' ? e.classList.add(attrs[k]) : 0) }
      else if (k === 'style') {
        Object.keys(attrs[k]).forEach(ks => {
          e.style[ks] = attrs[k][ks];
        });
      }
      else if (k === 'text') { attrs[k] === '' ? e.innerHTML = '&nbsp;' : e.innerText = attrs[k] }
      else e[k] = attrs[k];
    });
    return e;
  }


  document.querySelectorAll("select[multiple]").forEach((el, k) => {
    // already built (this script can run again after the Theme Editor re-renders the sidebar)
    if (el.nextElementSibling && el.nextElementSibling.classList.contains('multiselect-dropdown')) return;

    var uid = 'msd-' + (el.id || 'select') + '-' + k;
    var txtOf = function (name, fallback) { var v = el.getAttribute('multiselect-txt-' + name); return v != null ? v : fallback; };
    var txt = { selected: txtOf('selected', config.txtSelected), all: txtOf('all', config.txtAll), remove: txtOf('remove', config.txtRemove), search: txtOf('search', config.txtSearch), searchLabel: txtOf('search-label', config.txtSearchLabel) };
    var headingEl = el.closest('.option-list') && el.closest('.option-list').querySelector('.option-list__title');
    var heading = ((headingEl && headingEl.textContent) || '').replace(/\s+/g, ' ').trim() || config.placeholder;
    var fullName = function (o) { return (o.dataset && o.dataset.full) || o.text; };
    var div = newEl('div', { class: 'multiselect-dropdown', style: { width: config.style?.width ?? el.clientWidth + 'px', padding: config.style?.padding ?? '' } });
    // keyboard + screen reader semantics of the box (the mouse behaviour is unchanged)
    div.setAttribute('tabindex', '0');
    div.setAttribute('role', 'combobox');
    div.setAttribute('aria-haspopup', 'listbox');
    div.setAttribute('aria-expanded', 'false');
    div.setAttribute('aria-controls', uid + '-list');
    div.setAttribute('aria-label', heading);
    el.style.display = 'none';
    el.parentNode.insertBefore(div, el.nextSibling);
    var listWrap = newEl('div', { class: 'multiselect-dropdown-list-wrapper' });
    var list = newEl('div', { class: 'multiselect-dropdown-list', style: { height: config.height } });
    list.id = uid + '-list';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-multiselectable', 'true');
    list.setAttribute('aria-label', heading);
    var search = newEl('input', { class: ['multiselect-dropdown-search'].concat([config.searchInput?.class ?? 'form-control']), style: { width: '100%', display: el.attributes['multiselect-search']?.value === 'true' ? 'block' : 'none' }, placeholder: txt.search });
    search.setAttribute('aria-label', txt.searchLabel.replace('{heading}', function () { return heading.toLowerCase(); }));
    search.setAttribute('aria-controls', uid + '-list');
    search.setAttribute('aria-autocomplete', 'list');
    search.setAttribute('autocomplete', 'off');
    listWrap.appendChild(search);
    div.appendChild(listWrap);
    listWrap.appendChild(list);

    el.loadOptions = () => {
      list.innerHTML = '';

      if (el.attributes['multiselect-select-all']?.value == 'true') {
        var op = newEl('div', { class: 'multiselect-dropdown-all-selector' })
        var ic = newEl('input', { type: 'checkbox' });
        op.appendChild(ic);
        op.appendChild(newEl('label', { text: txt.all }));

        op.addEventListener('click', () => {
          op.classList.toggle('checked');
          op.querySelector("input").checked = !op.querySelector("input").checked;

          var ch = op.querySelector("input").checked;
          list.querySelectorAll(":scope > div:not(.multiselect-dropdown-all-selector):not(.multiselect-dropdown-group)")
            .forEach(i => { if (i.style.display !== 'none') { i.querySelector("input").checked = ch; i.optEl.selected = ch } });

          el.dispatchEvent(new Event('change'));

          document.dispatchEvent(new CustomEvent('multiselect:option-change', {
            detail: {
              value: op.optEl.value,
              text: op.optEl.text,
              checked: !op.querySelector("input").checked,
              select: el
            }
          }));
        });
        ic.addEventListener('click', (ev) => {
          ic.checked = !ic.checked;

          document.dispatchEvent(new CustomEvent('multiselect:option-change', {
            detail: {
              value: op.optEl.value,
              text: op.optEl.text,
              checked: !op.querySelector("input").checked,
              select: el
            }
          }));
        });
        el.addEventListener('change', (ev) => {
          let itms = Array.from(list.querySelectorAll(":scope > div:not(.multiselect-dropdown-all-selector):not(.multiselect-dropdown-group)")).filter(e => e.style.display !== 'none')
          let existsNotSelected = itms.find(i => !i.querySelector("input").checked);
          if (ic.checked && existsNotSelected) ic.checked = false;
          else if (ic.checked == false && existsNotSelected === undefined) ic.checked = true;
        });

        list.appendChild(op);
      }

      var addOption = (o) => {
        var op = newEl('div', { class: o.selected ? 'checked' : '', optEl: o })
        var ic = newEl('input', { type: 'checkbox', checked: o.selected });
        ic.setAttribute('tabindex', '-1');
        ic.setAttribute('aria-hidden', 'true');
        op.id = uid + '-opt-' + (list.children.length);
        op.setAttribute('role', 'option');
        op.setAttribute('aria-selected', o.selected ? 'true' : 'false');
        if (o.dataset && o.dataset.full) { op.setAttribute('aria-label', o.dataset.full); op.title = o.dataset.full; }
        op.appendChild(ic);
        op.appendChild(newEl('label', { text: o.text }));

        op.addEventListener('click', () => {
          op.classList.toggle('checked');
          op.querySelector("input").checked = !op.querySelector("input").checked;
          op.optEl.selected = !!!op.optEl.selected;
          op.setAttribute('aria-selected', op.optEl.selected ? 'true' : 'false');
          el.dispatchEvent(new Event('change'));
      
          document.dispatchEvent(new CustomEvent('multiselect:option-change', {
            detail: {
              value: op.optEl.value,
              text: op.optEl.text,
              checked: !op.querySelector("input").checked,
              select: el
            }
          }));
        });
        ic.addEventListener('click', (ev) => {
          ic.checked = !ic.checked;

          document.dispatchEvent(new CustomEvent('multiselect:option-change', {
            detail: {
              value: op.optEl.value,
              text: op.optEl.text,
              checked: !op.querySelector("input").checked,
              select: el
            }
          }));
        });
        o.listitemEl = op;
        list.appendChild(op);
      };

      // Plain <option>s as before; an <optgroup> adds a non-clickable heading row above its options
      Array.from(el.children).forEach(child => {
        if (child.tagName === 'OPTGROUP') {
          var groupHead = newEl('div', { class: 'multiselect-dropdown-group' });
          groupHead.setAttribute('role', 'presentation');
          groupHead.appendChild(newEl('span', { text: child.label }));
          list.appendChild(groupHead);
          Array.from(child.children).forEach(addOption);
        } else if (child.tagName === 'OPTION') {
          addOption(child);
        }
      });
      div.listEl = listWrap;

      div.refresh = () => {
        div.querySelectorAll('span.optext, span.placeholder').forEach(t => div.removeChild(t));
        var sels = Array.from(el.selectedOptions);
        div.setAttribute('aria-label', sels.length ? heading + ', ' + sels.length + ' ' + txt.selected + ': ' + sels.map(fullName).join(', ') : heading);
        if (sels.length > (el.attributes['multiselect-max-items']?.value ?? 5)) {
          div.appendChild(newEl('span', { class: ['optext', 'maxselected'], text: sels.length + ' ' + txt.selected }));
        }
        else {
          sels.map(x => {
            var c = newEl('span', { class: 'optext', srcOption: x });
            c.title = fullName(x);
            c.appendChild(newEl('span', { class: 'optlabel', text: x.text }));
            if ((el.attributes['multiselect-hide-x']?.value !== 'true')) {
              var del = newEl('span', { class: 'optdel', text: 'x', title: txt.remove + ' ' + fullName(x), onclick: (ev) => { c.srcOption.listitemEl.dispatchEvent(new Event('click')); div.refresh(); ev.stopPropagation(); } });
              // the x is a real control for the keyboard (Enter / Space, handled on the box below)
              del.setAttribute('role', 'button');
              del.setAttribute('tabindex', '0');
              del.setAttribute('aria-label', txt.remove + ' ' + fullName(x));
              c.appendChild(del);
            }

            div.appendChild(c);
          });
        }
        if (0 == el.selectedOptions.length) div.appendChild(newEl('span', { class: 'placeholder', text: el.attributes['placeholder']?.value ?? config.placeholder }));
      };
      div.refresh();
    }
    el.loadOptions();

    search.addEventListener('input', () => {
      var heading = null, headingHasMatch = false;
      var closeHeading = () => { if (heading) heading.style.display = headingHasMatch || search.value === '' ? '' : 'none'; };
      list.querySelectorAll(":scope div:not(.multiselect-dropdown-all-selector)").forEach(d => {
        if (d.classList.contains('multiselect-dropdown-group')) {
          closeHeading();
          heading = d;
          headingHasMatch = false;
          return;
        }
        // what the visitor sees, the stored value and every alias of the option ("united" finds United States shown as US; "uk" finds UK-GB)
        var opt = d.optEl;
        var txt = (d.querySelector("label").innerText + ' ' + (opt ? opt.value + ' ' + ((opt.dataset && opt.dataset.alias) || '').split('|').join(' ') : '')).toUpperCase();
        var match = txt.includes(search.value.toUpperCase());
        d.style.display = match ? 'block' : 'none';
        if (match) headingHasMatch = true;
      });
      closeHeading();
      setActive(null);
    });

    // ---- open / close, keyboard ----
    var isOpen = function () { return listWrap.style.display === 'block'; };
    var visibleRows = function () {
      return Array.from(list.children).filter(function (d) {
        return d.optEl && d.style.display !== 'none';
      });
    };
    var activeRow = null;
    function setActive(row) {
      if (activeRow) activeRow.classList.remove('is-active');
      activeRow = row;
      if (!row) { search.removeAttribute('aria-activedescendant'); return; }
      row.classList.add('is-active');
      search.setAttribute('aria-activedescendant', row.id);
      // keep the row inside the scrolling list (a sticky group heading covers the top ~36px)
      var rr = row.getBoundingClientRect(), lr = list.getBoundingClientRect();
      if (rr.top < lr.top + 36) list.scrollTop -= (lr.top + 36 - rr.top);
      else if (rr.bottom > lr.bottom) list.scrollTop += (rr.bottom - lr.bottom + 6);
    }
    function moveActive(delta, absolute) {
      var rows = visibleRows();
      if (!rows.length) return;
      var i = activeRow ? rows.indexOf(activeRow) : -1;
      if (absolute === 'first') i = 0;
      else if (absolute === 'last') i = rows.length - 1;
      else i = Math.max(0, Math.min(rows.length - 1, i + delta));
      setActive(rows[i]);
    }
    // the sticky sidebar can scroll inside itself on short screens: bring a cut-off panel fully into view
    function revealPanel() {
      var p = div.parentElement;
      while (p && p !== document.body && p !== document.documentElement) {
        var oy = getComputedStyle(p).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight) break;
        p = p.parentElement;
      }
      if (!p || p === document.body || p === document.documentElement) return;
      var pr = listWrap.getBoundingClientRect(), cr = p.getBoundingClientRect();
      if (pr.bottom > cr.bottom) p.scrollTop += pr.bottom - cr.bottom + 8;
    }
    function openPanel() {
      div.listEl.style.display = 'block';
      div.setAttribute('aria-expanded', 'true');
      div.classList.add('is-open');
      search.focus();
      search.select();
      revealPanel();
    }
    function closePanel(returnFocus, skipRefresh) {
      listWrap.style.display = 'none';
      div.setAttribute('aria-expanded', 'false');
      div.classList.remove('is-open');
      setActive(null);
      if (!skipRefresh) div.refresh();
      if (returnFocus) div.focus();
    }
    function toggleRow(row) {
      row.dispatchEvent(new Event('click'));
      search.focus();
    }

    div.addEventListener('click', () => {
      openPanel();
    });

    div.addEventListener('keydown', function (e) {
      var t = e.target;
      if (t === div) {
        // the box itself has focus
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); openPanel(); }
        else if (e.key === 'Escape' && isOpen()) { e.preventDefault(); closePanel(true); }
      } else if (t === search) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          if (!isOpen()) openPanel();
          moveActive(e.key === 'ArrowDown' ? 1 : -1);
        } else if (e.key === 'Home' && !search.value) { e.preventDefault(); moveActive(0, 'first'); }
        else if (e.key === 'End' && !search.value) { e.preventDefault(); moveActive(0, 'last'); }
        else if (e.key === 'Enter') { e.preventDefault(); if (activeRow) toggleRow(activeRow); }
        else if (e.key === ' ' && !search.value && activeRow) { e.preventDefault(); toggleRow(activeRow); }
        else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closePanel(true); }
        else if (e.key === 'Tab') {
          if (e.shiftKey) { e.preventDefault(); closePanel(true); }
          else {
            // update the tags now (the next Tab stop may be one of their x buttons), hide the panel once focus has moved on
            div.refresh();
            setTimeout(function () { if (document.activeElement !== search) closePanel(false, true); }, 0);
          }
        }
      } else if (t.classList && t.classList.contains('optdel')) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); div.focus(); }
      }
    });

    // syncOptions: re-read every option.selected into the rows and the tags (deep links set option.selected before or after the build)
    el.syncOptions = function () {
      Array.from(el.options).forEach(function (o) {
        var row = o.listitemEl;
        if (!row) return;
        row.classList.toggle('checked', o.selected);
        row.querySelector('input').checked = o.selected;
        row.setAttribute('aria-selected', o.selected ? 'true' : 'false');
      });
      div.refresh();
    };

    var onDocumentClick = function (event) {
      // the dropdown was removed (Theme Editor re-rendered the sidebar): stop listening so it can be freed
      if (!div.isConnected) {
        document.removeEventListener('click', onDocumentClick);
        return;
      }
      if (!div.contains(event.target)) {
        closePanel(false);
      }
    };
    document.addEventListener('click', onDocumentClick);
  });

  document.dispatchEvent(new CustomEvent('multiselect:ready'));

}

// after a Theme Editor section reload the window "load" event has long passed: build right away
if (document.readyState === 'complete') {
  MultiselectDropdown(window.MultiselectDropdownOptions);
} else {
  window.addEventListener('load', () => {
    MultiselectDropdown(window.MultiselectDropdownOptions);
  });
}
